<template>
  <div class="box">
    <div class="nav">
      <ul class="detail">
        <li class="name" @click="myIndex">一招建材网欢迎您</li>
        <li class="first" v-show="!userInfo.userName">
          <a @click="gotoLogin(0)">会员登录</a>
          <span class="line">|</span>
          <a @click="gotoLogin(1)">免费注册</a>
        </li>
        <li v-show="!!userInfo.userName">
          <Dropdown>
            <p class="userName-p">
              <!-- <Avatar class="person-icon" icon="person" size="small" />  -->
              <span class="userName">{{userInfo.userName}} </span>
            </p>
            <DropdownMenu slot="list">
                <div class="my-page">
                  <div class="my-info" @click="myInfo">
                    <Icon type="md-home" />
                    <p>我的主页</p>
                  </div>
                  <div class="sign-out" @click="signOutFun">
                    <Icon type="md-log-out" />
                    <p>退出登录</p>
                  </div>
                </div>
            </DropdownMenu>
          </Dropdown>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
  name: 'Header',
  created () {
    this.isLogin();
  },
  data () {
    return {
    };
  },
  computed: {
    ...mapState(['userInfo'])
  },
  methods: {
    ...mapActions(['signOut', 'isLogin']),
    changeCity (city) {
      this.city = city;
    },
    gotoLogin(type) {
      this.$Login({ 
        isRegister: type || 0 
      })
    },
    myIndex () {
      this.$router.push('/');
    },
    myInfo () {
      this.$router.push('/home');
    },
    signOutFun () {
      this.signOut();
      this.$router.push('/');
    }
  },
};
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  height: 40px;
  background-color: #FCFCFC;;
}
.nav {
  margin: 0 auto;
  overflow: hidden;
  width: @page-main-width;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  /* display: flex;
  flex-direction: row;
  justify-content: space-between; */
}
.nav ul {
  list-style: none;
}
.nav li {
  float: left;
  font-size: 14px;
  line-height: 35px;
  margin-right: 15px;
}
.nav .name{
  color: #8F8F8F;
  margin-right: 20px;
  cursor: pointer;
}
.nav .line{
  color: #000000;
  padding: 0 10px;
}
.nav a {
  text-decoration: none;
  color: #000000;
  cursor: pointer;
}
.nav a:hover {
  color: #d9534f;
}
.icon {
  color: #d9534f;
}
.first {
  color: #999999;
}
.first a:first-child {
  padding-left: 3px;
  border-left: none;
}
.person-icon {
  color: #d9534f;
  background-color:  #f0cdb2;
}
.userName {
  color: #000;
}
.shopping-cart-list {
  padding: 3px 15px;
}
.shopping-cart-box {
  margin: 8px 0px;
  margin-top: 15px;
  padding-bottom: 15px;
  height: 40px;
  display: flex;
  align-items: center;
  border-bottom: 1px #ccc dotted;
}
.shopping-cart-box:first-child {
  margin-top: 8px;
}
.shopping-cart-img {
  margin-right: 15px;
  width: 40px;
  height: 40px;
}
.shopping-cart-img img {
  width: 100%;
}
.shopping-cart-info {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-content: space-between;
  width: 200px;
  overflow: hidden;
  font-size: 12px;
  line-height: 20px;
  color: #999999;
}
.shopping-cart-detail {
  color: #999999;
}
.shopping-cart-text {
  color: #ccc;
}
.go-to-buy {
  display: flex;
  justify-content: flex-end;
}
.shopping-cart-null {
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.cart-null-icon {
  font-size: 38px;
  margin-bottom: 15px;
}
.shopping-cart-null span {
  color: #999999;
  font-size: 12px;
  line-height: 16px;
}
.userName-p {
  cursor: pointer;
}
.my-page {
  padding: 3px 5px;
  width: 180px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  /deep/.ivu-icon {
    color: #999;
  }
}
.my-page a {
  margin: 0px;
  padding: 0px;
  border: none;
}
.my-info {
  padding: 5px;
  width: 50%;
  height: 100%;
  text-align: center;
  cursor: pointer;
}
.my-info:hover {
  box-shadow: 0px 0px 5px #ccc;
}
.my-info i {
  font-size: 28px;
}
.my-info p {
  font-size: 12px;
}
.sign-out {
  padding: 5px;
  width: 50%;
  height: 100%;
  text-align: center;
  cursor: pointer;
}
.sign-out:hover {
  box-shadow: 0px 0px 5px #ccc;
}
.sign-out i {
  font-size: 28px;
}
.sign-out p {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/header/Header.vue